import { PlacementTypeProduct } from './PlacementTypeProduct';

export interface DrainPipeProduct extends PlacementTypeProduct {}
